import {Spinner} from '@primer/react'

import {RebaseState} from '../../../../hooks/mutations/use-stack-rebase-mutation'

export function RebasingIcon({state}: {state?: RebaseState}) {
  if (state !== RebaseState.Rebasing) return null

  // `srText={null}` because the row's trailing "Rebasing" label already conveys
  // the state to assistive technology; the default "Loading" text would be a
  // redundant announcement.
  return <Spinner size="small" srText={null} className="color-fg-attention" style={{marginLeft: -2}} />
}
